module.exports = __webpack_public_path__ + "static/support-logo-1a0b2c2de1e94b8d6a454ace6569b9b3.png";